import { accountStatsReducer } from "redux-store/ui-state/account-stats/reducers";

import { adDeliveryReportReducer } from "./ad-delivery-report";
import { contentGroupFormReducer } from "./content-group-form";
import { deviceEventsReducer } from "./device-events";
import { deviceEventsV3Reducer } from "./device-events-v3";
import { deviceIncidentsReducer } from "./device-incidents";
import { deviceResourceReducer } from "./device-resources";
import { deviceStatsReducer } from "./device-stats";
import { eventsV3Reducer } from "./events-v3";
import { incidentsReducer } from "./incidents/reducers";
import { mediaLibraryReducer } from "./media-library";
import { playerVersionsReducer } from "./player-versions/reducers";
import { deviceUptimeReportReducer } from "./report-uptime-device/reducers";
import { devicesUptimeReportReducer } from "./report-uptime-devices/reducers";
import { uptimeReportReducer } from "./report-uptime/reducers";
import { strategyDetailReducer } from "./strategy-v2/reducers";
import { tagsReducer } from "./tags/reducers";

// Define the ui-state store.
const pageReducers = {
  accountStats: accountStatsReducer,
  adDeliveryReport: adDeliveryReportReducer,
  contentGroupForm: contentGroupFormReducer,
  deviceEvents: deviceEventsReducer,
  deviceEventsV3: deviceEventsV3Reducer,
  deviceIncidents: deviceIncidentsReducer,
  deviceResources: deviceResourceReducer,
  deviceStats: deviceStatsReducer,
  devicesUptimeReport: devicesUptimeReportReducer,
  deviceUptimeReport: deviceUptimeReportReducer,
  eventsV3: eventsV3Reducer,
  incidents: incidentsReducer,
  mediaLibrary: mediaLibraryReducer,
  playerVersions: playerVersionsReducer,
  strategyDetail: strategyDetailReducer,
  tags: tagsReducer,
  uptimeReport: uptimeReportReducer,
};

export { pageReducers };
